import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";

const BookingConfirmationRetryModal = ({
  isOpen,
  message,
  onRetry,
  isRetrying = false,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className="booking-error-modal-overlay" role="presentation">
      <div
        className="booking-error-modal-panel"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="booking-error-message"
        onClick={(e) => e.stopPropagation()}
      >
        <p id="booking-error-message" className="booking-error-modal-message">
          {message}
        </p>
        <button
          type="button"
          className="btn-primary booking-error-modal-retry"
          onClick={onRetry}
          disabled={isRetrying}
        >
          {t("TRY_AGAIN")}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default BookingConfirmationRetryModal;
